import * as _ from 'lodash';
import moment from 'moment';

export class Mappeable {
    constructor(o) {
        _.forEach(_.keys(o), (k) => {
            if (moment(o[k], 'YYYY-MM-DD', true).isValid()) {
                this[k] = moment(o[k]).toDate();
            } else {
                this[k] = o[k];
            }
        })
    }
}